var map = {
	"./abb-color.svg": 1767,
	"./afb-color.svg": 1768,
	"./afb.svg": 1769,
	"./agro-color.svg": 1770,
	"./alb-color.svg": 1771,
	"./alb.svg": 1772,
	"./amb-color.svg": 1773,
	"./amb.svg": 1774,
	"./bbbaidja-color.svg": 1775,
	"./bbbaidjaxxx-color.svg": 1776,
	"./bdinidjaxxx-color.svg": 1777,
	"./bimb-color.svg": 1778,
	"./bimb.svg": 1779,
	"./bkr-color.svg": 1780,
	"./bkr.svg": 1781,
	"./bmriidja-color.svg": 1782,
	"./bniaidja-color.svg": 1783,
	"./bninidja-color.svg": 1784,
	"./bninidjaxxx-color.svg": 1785,
	"./boc-color.svg": 1786,
	"./bpay-color.svg": 1787,
	"./brinidja002-color.svg": 1788,
	"./bsmdidjaxxx-color.svg": 1789,
	"./bsn-color.svg": 1790,
	"./bsn.svg": 1791,
	"./btanidjaxxx-color.svg": 1792,
	"./cenaidja-color.svg": 1793,
	"./cenaidjaxxx-color.svg": 1794,
	"./cimb-color.svg": 1795,
	"./cimb.svg": 1796,
	"./citi-color.svg": 1797,
	"./citi.svg": 1798,
	"./default-bank-icon-color.png": 1799,
	"./default-bank-icon.png": 1800,
	"./gxbank-color.svg": 1801,
	"./hlb-color.svg": 1802,
	"./hlb.svg": 1803,
	"./hsbc-color.svg": 1804,
	"./hsbc.svg": 1805,
	"./ibbkidjaxxx-color.svg": 1806,
	"./kfh-color.svg": 1807,
	"./kwh-color.svg": 1808,
	"./kwh.svg": 1809,
	"./mbb-color.svg": 1810,
	"./mbb.svg": 1811,
	"./muamalat-color.svg": 1812,
	"./nispidjaxxx-color.svg": 1813,
	"./ocbc-color.svg": 1814,
	"./ocbc.svg": 1815,
	"./pbb-color.svg": 1816,
	"./pbb.svg": 1817,
	"./pinbidja-color.svg": 1818,
	"./raykat-color.svg": 1819,
	"./rhb-b.svg": 1820,
	"./rhb-color-b.svg": 1821,
	"./rhb-color.svg": 1822,
	"./rhb.svg": 1823,
	"./scb-color.svg": 1824,
	"./scb.svg": 1825,
	"./tng-color.svg": 1826,
	"./uob-color.svg": 1827,
	"./uob.svg": 1828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 110;